import { API_URL, postLogin } from "@/service/api";
import router from "../../router";
import Axios from "axios";

const routes = {
    api_token: "/api/token/",
};

const state = {
    drawer: false,
    accessToken: null,
    refreshToken: null,
    incorrectAuth: false,
    error: false,
    loggedIn: false,
    loading: false
}

const mutations = {
    toggleDrawer(state, payload) {
        state.drawer = payload;
    },
    updateStorage(state, { access, refresh }) {
        state.accessToken = access
        state.refreshToken = refresh
    },
    destroyToken(state) {
        state.accessToken = null
        state.refreshToken = null
        state.loading = false;
    },
    LOGIN_REQUEST(state) {
        state.loading = true;
        state.error = false;
    },
    LOGIN_ERROR(state) {
        state.error = true;
        state.loading = false;
        state.drawer = false;
    },
    LOGIN_SUCCESS(state) {
        state.error = false;
        state.loggedIn = true;
        state.loading = false;
        // state.drawer = true;
    },
    LOGIN_OUT(state) {
        state.error = false;
        state.loggedIn = false;
        state.loading = false;
    }
}

const actions = {
    userLogout(context) {
        if (context.getters.loggedIn) {
            context.commit('destroyToken')
        }
    },
    userLogin(context, usercredentials) {
        return new Promise((resolve, reject) => {
            postLogin({
                username: usercredentials.username,
                password: usercredentials.password
            })
                .then(response => {
                    context.commit('updateStorage', { access: response.data.access, refresh: response.data.refresh })
                    resolve()
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    DO_LOGOUT({ commit }) {
        commit("LOGIN_REQUEST");
        localStorage.removeItem("token");
        commit("toggleDrawer", false)
        commit("LOGIN_OUT");
        router.push('/login');
    },
    DO_LOGIN({ commit }, { username, password }) {
        commit("LOGIN_REQUEST");
        console.log('D0_LOGIN :>> ', API_URL, routes.api_token);
        Axios.post(
            API_URL + routes.api_token,
            { po_box: username, password },
            { headers: { "Content-Type": "application/json" } }
        )
            .then((res) => {
                const token = res.data.access;
                localStorage.setItem("token", token);
                router.push("/documents");
                commit("LOGIN_SUCCESS");
            })
            .catch(() => commit("LOGIN_ERROR"));
    },

}

const getters = {
    loggedIn(state) {
        return state.accessToken != null
    }
}

// exportar propiedades
export const auth = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
